import React from "react";
import { Outlet } from "react-router-dom";
import "./Chalan.css";
import { useSelector } from "react-redux";
import LinkButton from "../../utils/Components/LinkButton/LinkButton";
import { Box } from "@mui/material";

const classes = {
  chalanPage: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "2rem",
  },
  chalanActionContainer: {
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "2rem",
    padding: "2vmax",
    "& .MuiButton-root": {
      fontSize: "1rem",
      padding: "0.5vmax",
      textAlign: "center",
      textTransform: "none",
    },
  },
  listContainer: {
    width: "100%",
    minWidth: "50vw",
    minHeight: "50vh",
    position: "relative",
  },
};

function Chalan() {
  const statusAuth = useSelector((state) => state.dataReducer.statusAuth);
  console.log("statusAuth", statusAuth);

  return (
    <Box className="chalan-page" sx={classes.chalanPage}>
      <Box className="chalan-btns-contaner" sx={classes.chalanActionContainer}>
        <LinkButton to={"generatechalan"} className="ch-links">
          Generate Challan
        </LinkButton>

        {/* {statusAuth ? () => navigate("/dashbaord/chalan/chalans") : () => navigate("/dashbaord/chalan/generatechalan")} */}
        {statusAuth ? (
          <LinkButton to={"ewaybill"} className="ch-links">
            {/* Generate Chalan{" "} */}
            Generate Ewaybill
          </LinkButton>
        ) : (
          <LinkButton to={"ewaybillauth"} className="ch-links">
            Authentication
          </LinkButton>
        )}

        <LinkButton to={"localchalan"} className="ch-links">
          Freight Challan
        </LinkButton>
      </Box>
      <Box className="ch-list-bx" sx={classes.listContainer}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default Chalan;
